import React, {useEffect, useState} from "react";
import {Modal} from "../../../../components/modal/modal.jsx";
import Button from "../../../../components/button/button.jsx";
import DispatchService from "../../../../services/dispatch/dispatch-service.js";
import projectUtils from "../../../../utils/project-utils.js";
import {formatCaseCard} from "../utils/dashboard-formatters.js";

const AttendanceAssignmentModal = ({payload, onClose, onSuccess}) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const open = Boolean(payload);
    const attendance = payload?.attendance;
    const garrison = payload?.garrison;

    useEffect(() => {
        if (!open) return;
        setIsSubmitting(false);
    }, [open]);

    const handleSubmit = async () => {
        if (!payload?.garrisonId || !payload?.attendanceId) {
            projectUtils.swalErrorMessage("Erro", "Não foi possível identificar a guarnição e o atendimento.", "Ok");
            return;
        }

        setIsSubmitting(true);

        try {
            await DispatchService.dispatchAssignment({
                garrisonId: payload.garrisonId,
                attendanceId: payload.attendanceId,
                taskId: null,
            });

            onSuccess();
            projectUtils.swalSuccessMessage("success", "Sucesso", "Item atribuído com sucesso.", "Ok");
        } catch (error) {
            console.error("Erro ao atribuir atendimento pelo dashboard:", error);
            const message = error.response?.data ?? "Não foi possível atribuir o atendimento.";
            projectUtils.swalErrorMessage("Erro", message, "Ok");
            setIsSubmitting(false);
        }
    };

    return (
        <Modal open={open} setOpen={onClose} title="Atribuir" className="w-full max-w-2xl" isCloseClick={false}>
            <Modal.Body className="max-h-[calc(100vh-180px)] flex flex-col gap-4 overflow-auto">
                <div>
                    <p className="text-[14px] font-bold text-[#676a6c]">Guarnição</p>
                    <span className="text-sm text-[#555]">{garrison?.name ?? garrison?.garrisonName}</span>
                </div>

                <div className="flex flex-col">
                    <p className="text-[14px] font-bold text-[#676a6c]">Atendimento</p>
                    <span className="text-sm text-[#555]">{attendance?.natureText ?? attendance?.nature}</span>
                    <span className="text-sm text-[#555]">{attendance?.place ? formatCaseCard(attendance.place) : null}</span>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button type="button" target="primary" onClick={handleSubmit} loading={isSubmitting} actionFeedbackType='save'>

                    Salvar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AttendanceAssignmentModal;